/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown>, price: NonNullable<unknown>, total: NonNullable<unknown> }} Partner_Manage_Copilot_CalcInputs */



/**
* | output |
* | --- |
* | "{seats} seats × {price} = {total}/mo" |
*
* @param {Partner_Manage_Copilot_CalcInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_copilot_calc = /** @type {((inputs: Partner_Manage_Copilot_CalcInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Copilot_CalcInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.seats} Plätze × ${i?.price} = ${i?.total}/Mon.`)
	return /** @type {LocalizedString} */ (`${i?.seats} seats × ${i?.price} = ${i?.total}/mo`)
});